import { useListApiKeys } from '@/modules/api/codegen';

export const useApiKeysList = () => useListApiKeys();
